import { Vue, Component, Ref, Prop, Emit, Watch } from 'vue-property-decorator'
import { Nullable } from '@/shared/types/app.types'
import { BModal } from 'bootstrap-vue'
import { ConfigurationPreformattedCreateRequest, ConfigurationPreformattedPatchInBatchRequest, ConfigurationPreformattedResponse } from '@/modules/configurationModule/detail/local-samples/preformatted/services/preformatted.dto'
import { initialLocalPreformattedModalBasicFormState, LocalPreformattedModalBasicFormState } from '@/modules/configurationModule/detail/local-samples/preformatted/components/preformatted-modal-basic-form/preformatted-modal-basic-form.model'

@Component
export default class LocalPreformattedModalBasicForm extends Vue {
    @Ref() readonly localPreformattedModal!: BModal
    @Prop(String) readonly actionTitle!: string
    @Prop() readonly selectedRow!: Nullable<ConfigurationPreformattedResponse>
    @Emit()
    update(preformattedBasicFormDataPatch: ConfigurationPreformattedPatchInBatchRequest): ConfigurationPreformattedPatchInBatchRequest {
        return preformattedBasicFormDataPatch
    }
    @Emit()
    create(preformattedBasicFormDataCreate: ConfigurationPreformattedCreateRequest): ConfigurationPreformattedCreateRequest {
        return preformattedBasicFormDataCreate
    }
    @Watch('selectedRow', { immediate: true, deep: true })
    onChangeSelectedRow(val: Nullable<ConfigurationPreformattedResponse>): void {
        if (val) {
            this.state = {
                ...this.state,
                id: val?.id,
                active: val?.active,
                title: val?.title
            }
        }
    }

    state: LocalPreformattedModalBasicFormState
    constructor() {
        super()
        this.state = initialLocalPreformattedModalBasicFormState()
    }

    get canShowInfoMessage(): boolean {
        return !this.state?.id
    }

    get canUpdate(): boolean {
        const hasError: boolean = !!this.errors.count()
        const anyFieldIsDirty = this.$_someFieldIsDirty(this.fields)
        return !hasError && anyFieldIsDirty
    }

    spreadEvent(): void {
        if (this.state?.id) {
            const patchRow: ConfigurationPreformattedPatchInBatchRequest = {
                id: this.state.id,
                active: this.state.active,
                title: this.state.title
            }
            this.update(patchRow)
        } else {
            const postRow: ConfigurationPreformattedCreateRequest = {
                active: this.state?.active,
                title: this.state?.title
            }
            this.create(postRow)
        }
    }
}
